import React from "react";
import Scholarships from "../../components/Scholarships/Scholarships";

const ScholarshipsPage = () => {
  return <Scholarships />;
};

export default ScholarshipsPage;
